import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import locale from 'antd/es/date-picker/locale/ru_RU';

// Подключаем плагин для кастомного парсинга формата
dayjs.extend(customParseFormat);

// Настраиваем dayjs для русской локализации
dayjs.locale('ru');

// Кастомная локаль для DatePicker с правильной настройкой выбора года
export const customLocale = {
    ...locale,
    // Настраиваем панель выбора года для разрешения выбора прошлых лет
    yearFormat: 'YYYY',
    monthFormat: 'MMMM',
    dateFormat: 'DD.MM.YYYY',
    dateTimeFormat: 'DD.MM.YYYY HH:mm:ss',
    weekFormat: 'wo',
    weekStart: 1, // Понедельник
};

// Функция для получения значения даты из события
// Предотвращает парсинг частичного ввода, чтобы избежать подстановки текущей даты
export const getDateValueFromEvent = (value: any): dayjs.Dayjs | null => {
    // Если это уже dayjs объект и валидный, возвращаем как есть
    if (value && dayjs.isDayjs(value) && value.isValid()) {
        return value;
    }
    
    // Если это null или undefined, возвращаем null
    if (value === null || value === undefined) {
        return null;
    }
    
    // Для строк парсим только полностью введенную дату
    if (typeof value === 'string' && value.trim() !== '') {
        // Проверяем формат DD.MM.YYYY (полностью введенная дата с 4-значным годом)
        const dateRegex = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/;
        const match = value.trim().match(dateRegex);
        
        if (match) {
            const day = parseInt(match[1], 10);
            const month = parseInt(match[2], 10);
            const year = parseInt(match[3], 10);
            
            // Проверяем валидность диапазонов
            if (day >= 1 && day <= 31 && month >= 1 && month <= 12 && year >= 1900 && year <= 2100) {
                // Создаем дату в явном формате YYYY-MM-DD для избежания проблем с парсингом
                const dateString = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
                const parsed = dayjs(dateString, 'YYYY-MM-DD', true); // strict mode
                if (parsed.isValid() && parsed.year() === year && parsed.month() + 1 === month && parsed.date() === day) {
                    return parsed;
                }
            }
        }
        
        // Для частичного ввода или невалидной даты возвращаем null
        // Это предотвратит подстановку текущей даты
        return null;
    }
    
    return value || null;
};

// Общие пропсы для DatePicker
export const datePickerProps = {
    format: 'DD.MM.YYYY' as const,
    locale: customLocale,
    placeholder: 'Выберите дату (ДД.ММ.ГГГГ)',
    picker: 'date' as const,
    allowClear: true,
    showToday: true,
    disabledDate: () => false, // Разрешаем выбор любых дат, включая прошлые
    inputReadOnly: false,
    style: { width: '100%' } as const,
};

